<div class="pagination-container w-100" *ngIf="totalPages > 1">
  <ul *ngIf="pages && pages.length > 1" class="pagination mt-2 pb-2 cursor">
    <li [ngClass]="{'pagination-disable': isFirstPage}" class="page-item first-item">
      <a (click)="onPaginateChange(1)" class="page-link" data-toggle="tooltip" title="First">
        <em class="fas fa-angle-double-left mr-2"></em>
      </a>
    </li>
    <li [ngClass]="{'pagination-disable': isFirstPage}" class="page-item previous-item">
      <a (click)="onPaginateChange(currentPage - 1)" class="page-link" data-toggle="tooltip" title="Previous">
        <em class="fas fa-angle-left mr-2"></em>
      </a>
    </li>
    <li *ngFor="let page of pages" [ngClass]="{active: currentPage === page}" class="page-item number-item">
      <a (click)="onPaginateChange(page)" class="page-link">{{page}}</a>
    </li>
    <li [ngClass]="{'pagination-disable': isLastPage}" class="page-item next-item">
      <a (click)="onPaginateChange(currentPage + 1)" class="page-link" data-toggle="tooltip" title="Next">
        <em class="fas fa-angle-right mr-2"></em>
      </a>
    </li>
    <li [ngClass]="{'pagination-disable': isLastPage}" class="page-item last-item">
      <a (click)="onPaginateChange(pages[pages?.length-1])" class="page-link" data-toggle="tooltip" title="Last">
        <em class="fas fa-angle-double-right mr-2"></em>
      </a>
    </li>
  </ul>
</div>